import { DesignToken } from "@livechat/design-system-react-components";

import { ReportDistribution } from "constants/reports/distribution";
import { withVar } from "themes/helpers";

import { getFormatedPercent, getLabelsFromPeriod, getSeriesDataFromPeriod, sumValueFromPeriod } from "../helpers";
import { IChartData } from "../interfaces";

const ratedGreatColor = withVar(DesignToken.DecorGreen500);
const ratedOkayColor = withVar(DesignToken.DecorBlue500);
const ratedBadColor = withVar(DesignToken.DecorRed500);

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function ratingDeserializer(ratingResponse: any, distribution: ReportDistribution): IChartData {
  const ratedGreat = sumValueFromPeriod(ratingResponse, "good");
  const ratedOkay = sumValueFromPeriod(ratingResponse, "neutral");
  const ratedBad = sumValueFromPeriod(ratingResponse, "bad");
  const ratedTotal = ratedGreat + ratedOkay + ratedBad;

  const chartDataFromRatedGreat = getSeriesDataFromPeriod(ratingResponse, "good", distribution);
  const chartDataFromRatedOkay = getSeriesDataFromPeriod(ratingResponse, "neutral", distribution);
  const chartDataFromRatedBad = getSeriesDataFromPeriod(ratingResponse, "bad", distribution);
  const labels = getLabelsFromPeriod(ratingResponse, distribution);

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
  const labelMapper = (value: any, index: any) =>
    `(${getFormatedPercent(
      value / (chartDataFromRatedGreat[index] + chartDataFromRatedOkay[index] + chartDataFromRatedBad[index]),
      0
    )})`;

  return {
    summary: [
      {
        name: "Rated great",
        value: ratedGreat,
        color: ratedGreatColor,
        label: `(${getFormatedPercent(ratedGreat / ratedTotal)})`,
        urlParams: {
          rate: "rated_good",
        },
      },
      {
        name: "Rated okay",
        value: ratedOkay,
        color: ratedOkayColor,
        label: `(${getFormatedPercent(ratedOkay / ratedTotal)})`,
        urlParams: {
          rate: "rated_okay",
        },
      },
      {
        name: "Rated bad",
        value: ratedBad,
        color: ratedBadColor,
        label: `(${getFormatedPercent(ratedBad / ratedTotal)})`,
        urlParams: {
          rate: "rated_bad",
        },
      },
    ],
    labels,
    series: [
      {
        name: "rated great",
        slug: "rated_good",
        data: chartDataFromRatedGreat,
        label: chartDataFromRatedGreat.map(labelMapper),
        color: ratedGreatColor,
      },
      {
        name: "rated okay",
        slug: "rated_okay",
        data: chartDataFromRatedOkay,
        label: chartDataFromRatedOkay.map(labelMapper),
        color: ratedOkayColor,
      },
      {
        name: "rated bad",
        slug: "rated_bad",
        data: chartDataFromRatedBad,
        label: chartDataFromRatedBad.map(labelMapper),
        color: ratedBadColor,
      },
    ],
  };
}
